<script setup>
import { onMounted, ref, watch } from 'vue';
import { useFinancialModelsStore } from '@/stores/financialModels';
import { DataTable } from 'simple-datatables';
import Spinner from '@/components/Spinner.vue';
import { useRouter, useRoute } from 'vue-router';

const store = useFinancialModelsStore();
const pdfUrl = ref(null);
const router = useRouter();
const route = useRoute();
const baseUrl = process.env.VUE_APP_BASE_URL;
const portfolioName = ref('');

let dataTableBasic = null; // Store DataTable instance

const viewDocument = (url) => {
  const fullUrl = `${baseUrl}${url.startsWith('/') ? url : '/' + url}`;
  console.log('Viewing document:', fullUrl);
  pdfUrl.value = fullUrl;
};

// Extract initialization logic into a reusable function
const initializeTable = async (portfolioId) => {
  await store.fetchFinancialModels(portfolioId);

  // Get portfolio name from first row
  if (store.financialModels.length > 0) {
    portfolioName.value = store.financialModels[0].portfolio.name;
  }

  // Destroy existing DataTable if it exists
  if (dataTableBasic) {
    dataTableBasic.destroy();
  }

  // Initialize DataTable
  dataTableBasic = new DataTable("#datatable-basic", {
    searchable: true,
    fixedHeight: true,
  });

  // Add rows to the DataTable
  store.financialModels.forEach((financialModel) => {
    dataTableBasic.rows.add([
      [
        financialModel.title,
        `<a href="#" class="view-document" data-url="${financialModel.document.url}">View Document</a>`,
        financialModel.portfolio.name,
        new Date(financialModel.createdAt).toLocaleDateString(),
        new Date(financialModel.updatedAt).toLocaleDateString(),
      ],
    ]);
  });
};

onMounted(async () => {
  await initializeTable(route.params.portfolioId);

  // Use event delegation for link clicks
  document.querySelector("#datatable-basic").addEventListener("click", (event) => {
    if (event.target.matches(".view-document")) {
      event.preventDefault();
      const url = event.target.getAttribute("data-url");
      console.log('Link clicked, URL:', url);
      viewDocument(url);
      router.push({ path: '/pdf-viewer', query: { url: url } });
    }
  });
});

// Watch for changes to portfolioId parameter
watch(
  () => route.params.portfolioId,
  async (newPortfolioId) => {
    if (newPortfolioId) {
      await initializeTable(newPortfolioId);
    }
  }
);
</script>
<template>
    <div class="py-4 container-fluid">
    <div class="mt-4 row">
      <div class="col-12">
        <div class="card">
          <!-- Card header -->
          <div class="card-header">
            <h5 class="mb-0">Financial Models</h5>
            <p class="mb-0 text-sm">
              Portfolio: {{ portfolioName }}
            </p>
          </div>
          <div class="table-responsive">

            <table id="datatable-basic" class="table table-flush">
              <thead>
                <tr>
                  <th>Document Title</th>
                  <th>Document URL</th>
                  <th>Portfolio Name</th>
                  <th>Created At</th>
                  <th>Updated At</th>
                </tr>
              </thead>
              <tbody>
                <!-- Rows will be added dynamically -->
              </tbody>
            </table>
            <Spinner :isLoading="store.isLoading" />
            <div v-if="error">{{ error }}</div>
    <!-- PDF Viewer -->
    <PdfViewer v-if="pdfUrl" :pdfUrl="pdfUrl" />
          </div>
      </div>
    </div>
  </div>
  </div>


</template>
